// layouts/master-page-auth-messenger.js
// ─────────────────────────────────────────────────────────
// Layout สำหรับ Messenger เท่านั้น
// - เช็คแค่ token (ไม่เช็ค menuData / GetAuthInPage)
// - ไม่มี Sidebar และ Topbar แบบ Admin
// ─────────────────────────────────────────────────────────

import React from "react";
import { Navigate, useOutlet } from "react-router-dom";
import { CheckTokenExpire } from "../components/utils/atuhen";
import {
    GetDataToken,
    GetDataRefreshToken,
    GetDataUserGroup,
} from "../components/utils/data-storage";

const MESSENGER_GROUP_ID = 3; // ตรงกับที่ตั้งใน messenger-login.jsx

const MasterPageAuthMessenger = () => {
    const outlet       = useOutlet();
    const accessToken  = GetDataToken();
    const refreshToken = GetDataRefreshToken();
    const userGroup    = GetDataUserGroup();

    // ── 1. เช็คว่ามี token ไหม ───────────────────────────
    if (!accessToken || !refreshToken) {
        return <Navigate to="/login" replace />;
    }

    // ── 2. เช็ค token หมดอายุไหม (ข้ามถ้าเป็น MOCK) ─────
    const isMock = accessToken === 'MOCK_TOKEN';
    if (!isMock) {
        try {
            const accessExpired  = CheckTokenExpire(accessToken);
            const refreshExpired = CheckTokenExpire(refreshToken);
            if (accessExpired && refreshExpired) {
                return <Navigate to="/login" replace />;
            }
        } catch (e) {
            // token decode ไม่ได้ → ให้ไป login ใหม่
            return <Navigate to="/login" replace />;
        }
    }

    // ── 3. เช็คว่าเป็น Messenger group เท่านั้น ──────────
    if (String(userGroup) !== String(MESSENGER_GROUP_ID)) {
        return <Navigate to="/login" replace />;
    }

    // ── UI ────────────────────────────────────────────────
    return (
        <div className="messenger-layout">
            {outlet}
        </div>
    );
};

export default MasterPageAuthMessenger;